import { useAppParams } from '@klp/core/app/useAppParams';

import { useGetByggMoteromQuery } from '../rtkApi';

export const useByggMoterom = (byggNummer: string | undefined) => {
    const { selectedClient } = useAppParams();
    const kundenummer = selectedClient?.kundeNummer;

    const { data: byggMoteromList = [] } = useGetByggMoteromQuery(
        { byggNummer: byggNummer!, kundenummer: kundenummer! },
        { skip: !byggNummer || !kundenummer },
    );

    return { byggMoteromList };
};
